import axios from "api/client";
export default {
  all: (options = { params: {} }) => axios.get(`/orders`, options),
};
